const initialState = { incidentlogs: [] }

export const incidentlogs = (state = initialState, action) => {
	switch (action.type) {
  	case 'SET_INCIDENT_LOGS':
      return { incidentlogs: action.payload }; 
  }
  return state
}
